import { useLayoutEffect } from 'react'
import { useLocation } from 'react-router-dom'

export const scrollViewportToTop = () => {
  const root = document.documentElement
  const previousScrollBehavior = root.style.scrollBehavior

  root.style.scrollBehavior = 'auto'
  window.scrollTo(0, 0)
  root.style.scrollBehavior = previousScrollBehavior
}

const ScrollToTop = () => {
  const { pathname } = useLocation()

  useLayoutEffect(() => {
    scrollViewportToTop()
  }, [pathname])

  return null
}

export default ScrollToTop
